import { create } from 'zustand';
import type { Session, User } from '@supabase/supabase-js';
import { runSessionResetHandlers } from '../../shared/ports/sessionResetPort';
import { setSentryUser } from '../../shared/sentry/sentryUser';

interface AuthState {
  session: Session | null;
  user: User | null;
  loading: boolean;
  error?: string;
  setLoading: (value: boolean) => void;
  setError: (message?: string) => void;
  setSession: (session: Session | null, user: User | null) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  loading: false,
  error: undefined,
  setLoading: (value) => set({ loading: value }),
  setError: (message) => set({ error: message }),
  setSession: (session, user) =>
    set((state) => {
      const nextUser = user ?? session?.user ?? null;
      const prevId = state.user?.id;
      const nextId = nextUser?.id;
      if (prevId !== nextId) {
        void runSessionResetHandlers();
      }
      setSentryUser(nextUser);
      return { session, user: nextUser, error: undefined, loading: false };
    }),
  clearSession: () => {
    void runSessionResetHandlers();
    setSentryUser(null);
    set({ session: null, user: null, loading: false, error: undefined });
  },
}));
